import { Component, ComponentClass } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/ShareButton/ShareButton.styl'
import { ShareMethod, ShareableInfo } from 'interfaces/share'
import Overflower from 'components/features/pfm/Overflower/Overflower'
import FacebookIcon from 'icons/share_facebook.svg'
import TwitterIcon from 'icons/share_twitter.svg'
import EmailIcon from 'icons/share_email.svg'
import NativeIcon from 'icons/share_native.svg'
import { generateShareUrl } from 'helpers/socialHelpers'
import SvgIcon from 'components/atoms/SvgIcon'
import { IS_EDGE } from 'helpers/userAgentHelpers'

export type ShareButtonOwnProps = ShareableInfo

export type ShareButtonDispatchProps = {
  onShare: (shareable: ShareableInfo) => void
}

type ButtonStat = {
  copy: string
  Icon: ComponentClass
}
const BUTTON_STATS: Record<ShareMethod, ButtonStat> = {
  facebook: { copy: 'Post', Icon: FacebookIcon },
  twitter: { copy: 'Tweet', Icon: TwitterIcon },
  email: { copy: 'Email', Icon: EmailIcon },
  native: { copy: 'Share', Icon: NativeIcon },
}

type ShareButtonProps =
  & ShareButtonDispatchProps
  & ShareButtonOwnProps

class ShareButton extends Component<ShareButtonProps> {

  render () {
    const { method, children } = this.props
    const shareMethod = method as ShareMethod
    const className = cn(styles.shareButton, styles[shareMethod], {
      [styles.edge]: IS_EDGE,
    })
    const { Icon, copy } = BUTTON_STATS[shareMethod]

    const copyChild = (
      <span className={ styles.text }>
        { children || copy }
      </span>
    )

    const iconChild = (
      <span className={ styles.icon }>
        <SvgIcon src={ Icon } />
      </span>
    )

    const href = method === 'email' ? generateShareUrl(this.props) : undefined

    return (
      <a
        className={ className }
        href={ href }
        onClick={ this.handleClick }
        target='_blank'
        rel='noopener noreferrer'
      >
        <Overflower>
          <Overflower.Short>
            { copyChild }
          </Overflower.Short>
          <Overflower.Long>
            <div className={ styles.longOption }>
              { iconChild }
              { copyChild }
            </div>
          </Overflower.Long>
        </Overflower>
      </a>
    )
  }

  private handleClick = () => {
    this.props.onShare(this.props)
  }
}

export default ShareButton
